/** @jsxImportSource @emotion/react */
import React, { CSSProperties } from 'react';
import { jsx, css } from '@emotion/react';
import { colors } from '@atlaskit/theme';
import { SerializedStyles } from '@emotion/serialize';

type Props = {
  primaryText?: React.ReactNode;
  secondaryText?: React.ReactNode;
  className?: string;
}

export const truncateCss = css`
    display: block;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const primaryTextCss = css`
  ${truncateCss};
`;

const secondaryTextCss = css`
  ${truncateCss};
  font-size: 0.85em;
  color: ${colors.subtleText()};
`;

const Cell: React.FC<Props> = ({primaryText, secondaryText, className}) => {

  return (<div className={className} css={css`max-width: 100%;
    `}>
    {primaryText && <div css={primaryTextCss}>{primaryText}</div>}
    {secondaryText && <div css={secondaryTextCss}>{secondaryText}</div>}
  </div>);
};

export default React.memo(Cell);
